import React, { useState } from "react";
import "./RequestSection.scss";
import { Modal, Row, Col } from "react-bootstrap";
import { ButtonV1 } from "lib";
import { useDispatch, useSelector } from "react-redux";
import { postRequestedDocs } from "api/dashboardDetail";
// import { useParams } from "react-router-dom";
// import Toast from "components/ToastComponent";
import {DropdownV1} from ".."

const RequestSectionModal = (props) => {
  const urlParams = useSelector((state) => state?.urlEncryption?.urlParams);
  const {
    show,
    onHide,
    blockSection,
    blockGroup,
    blockName,
    requestedFlow,
    editFontSize,
    subHeading,
    customButton,
    formFields,
    blockId,
    assignee_required,
    role,
    user,
    notification,
    request_change_option


  } = props;
  const [comment, setComment] = useState("");
  const [dropdownV1Value, setDropdownV1Value] = useState({})
  const [selectedUser,setSelectedUser] = useState({})
  const dispatch = useDispatch();
  const organisationInfo = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo)

  const currentSubWorkFlowId = useSelector(
    (state) => state?.dashboardDetailReducer?.currentSubWorkFlowId
  );
  const workFlowCreatedBy = useSelector((state)=>state?.dashboardDetailReducer.workFlowInfo.created_by)

  const userSubworkFlowInfo = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo
  );
  const dashboardDetailData = useSelector(
    (state) =>
      state?.dashboardDetailReducer?.dashboardDetailData?.subworkFlowInfo
  );
  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  )?.organisationInfo?._id;

  const profileData = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  )?.profileInfo;

  const requestedItem= formFields?.options?.list_items.find(item=>{
    return  item?.id === blockId
 })
 const all_users = useSelector((state)=> state.dashboardReducer?.allUsers)

  const handleSend = () => {
    const obj = {};
    const body = {
      comment,
      email: assignee_required == 'true' ? selectedUser?.email_id  : dashboardDetailData?.email,
      createdBy: profileData?.userId,
      profileData: selectedUser.profileData||[],
      request_change_option: request_change_option || 'user',
      name:  assignee_required == 'true' ? selectedUser?.first_name + ' ' +selectedUser?.last_name  : dashboardDetailData?.full_name,
      requestedFlow: requestedFlow ? requestedFlow : "updateSection",
      active_section: blockSection,
      active_group: blockGroup,
      blockName: blockName,
      internalUserName: profileData.first_name + " " + profileData.last_name,
      // has_link_expiry: organisationInfo?.has_link_expiry,
      hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
      customButton : customButton,
      applicationInitiatedBy :dashboardDetailData?.created_by,
      communication_poc:requestedItem?.communication_poc,
      assignee_required:assignee_required,
    };
    obj.body = body;
    const params = {
      primaryWorkflowId: urlParams?.primaryWorkflowId,
      userId: userSubworkFlowInfo.user_id || userSubworkFlowInfo.applicant_id,
      subWfId: currentSubWorkFlowId,
      organisation_id: organisation_id,
    };
    obj.params = params;
    if (
      obj &&
      params?.primaryWorkflowId &&
      params?.userId &&
      params?.subWfId &&
      organisation_id
    ) {
      dispatch(postRequestedDocs(obj));
    }
    onHide();
  }

  const dropdownv1OnChange=(e)=>{
    const { name, value } = e.target;
    let obj ={}
    if (request_change_option === "role") {
      let userList;
      if(user?.includes('creator')){
          userList= all_users.filter(
          (obj) => (obj?.role === value&&obj?._id===workFlowCreatedBy)
        )
      }else{
        userList= all_users.filter(
        (obj) => obj?.role === value
      );
      }
      let profileDetails = userList.map(({ _id, profile, email_id,mobile_number }) => ({ _id, profile, email_id ,mobile_number}));
      obj = {
        profileData: profileDetails,
      };
     
    } else {
    let selected_user = all_users.filter((e)=>{return e._id == value})
    if(selected_user?.length){
      selected_user =selected_user[0]
      obj = { ...selected_user?.profile,email_id : selected_user?.email_id, mobile_number : selected_user?.mobile_number, _id:selected_user._id }
    }
  }
    setSelectedUser(obj)
    setDropdownV1Value({[name] : value})
  }

  return (
    <Modal
      size="md"
      className=""
      show={show}
      onHide={onHide}
      centered
      scrollable
      backdrop="static"
      // style={{
      //   padding: "4rem",
      //   width: "45vw",
      //   marginLeft: "30vw",
      // }}
    >
      <Modal.Header closeButton className="modal_headers mt-2 mx-2 pb-0 mb-4">
        <Modal.Title className="req_change_title fs-20px fw-bold text-theme">
          Request section change
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="mx-1">
        <div className="multi_ddTConatiner px-1">
          {subHeading && (
            <h4 className={`text-center fs-18px ${editFontSize ? editFontSize : ""}`}>
              {subHeading}{blockName}
            </h4>
          )}
        </div>
        <Row className="row_comments_heading mx-0 mt-4">
          <div className="comments_head mb-1 commentsTextRequestchangeStyle">
            Remarks (please enter more than 15 Character) 
          </div>
          <input
            value={comment}
            onChange={(e) => setComment(e.target.value.trimStart())}
            // onBlur={(e)=> setComment(e.target.value.trim())}
            type="text"
            className="w-100 border border-1 h-35px border-black"
            required="true"
            pattern=""
            re
          />
        </Row>
        {assignee_required && assignee_required == 'true' ? <Row className="row_comments_heading mx-0 mt-4">
          <DropdownV1 
              options_type = {"all_users"}
              label = {"Assignee"}
              onChange = {dropdownv1OnChange}
              name = {"user_assignee"}
              value = {dropdownV1Value}
              selectedData = {dropdownV1Value}  
              isEditable ={true}
              size={'px-0'}
              request_change_option ={request_change_option}
              role = {role}
              user = {user}
              notification = {notification}
              workFlowCreatedBy={workFlowCreatedBy}
           />
        </Row> :''}
        <Row className="d-flex buttons_conatiner mt-2">
          <Col lg={6} xs={6} onClick={onHide} className="backButton light_button">
            Back
          </Col>
          <Col lg={6} xs={6} className="send_button">
            {" "}
            <ButtonV1
              label="YES"
              className="primary_button"
              disabled={! (comment?.length > 15 && (assignee_required == 'true' ? dropdownV1Value.hasOwnProperty('user_assignee')? dropdownV1Value['user_assignee'].length != 0 : false : true))}
              onClick={handleSend}
              
            />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default RequestSectionModal;
